var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ResponseTime"},[(!_vm.responseTime)?_c('div',{staticClass:"placeholder"}):_c('div',{class:_vm.classes,style:(_vm.styles)},[_vm._v(" "+_vm._s(_vm._f("responseTime")(_vm.responseTime))+" sec ")])])}
var staticRenderFns = []

export { render, staticRenderFns }